// Service Worker Registration
export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          console.log('SW registered: ', registration);
          
          // Check for updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New content available, show update prompt
                if (window.confirm('Nueva versión disponible. ¿Actualizar ahora?')) {
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                  window.location.reload();
                }
              }
            });
          });
        })
        .catch((error) => {
          console.log('SW registration failed: ', error);
        });
    });
  }
  
  // Initialize beforeinstallprompt listener globally
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();
    // Store the event globally so it can be triggered later
    window.deferredPrompt = e;
    console.log('PWA install prompt available (global)');
  });

  window.addEventListener('appinstalled', () => {
    // Clear the deferredPrompt
    window.deferredPrompt = null;
    console.log('PWA was installed');
  });
}

// PWA Install Prompt (for backwards compatibility)
export function initInstallPrompt(setInstallable) {
  // Check if prompt already available
  if (window.deferredPrompt) {
    setInstallable(true);
  }
  
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.deferredPrompt = e;
    setInstallable(true);
    console.log('PWA install prompt available');
  });

  window.addEventListener('appinstalled', () => {
    window.deferredPrompt = null;
    setInstallable(false);
    console.log('PWA was installed');
  });
}

export async function installPWA() {
  if (!window.deferredPrompt) {
    console.log('Install prompt not available');
    return false;
  }

  // Show the install prompt
  window.deferredPrompt.prompt();
  
  // Wait for the user to respond to the prompt
  const { outcome } = await window.deferredPrompt.userChoice;
  console.log(`User response to install prompt: ${outcome}`);
  
  // Clear the deferredPrompt
  window.deferredPrompt = null;
  
  return outcome === 'accepted';
}

// Check if app is installed
export function isAppInstalled() {
  // Check if running in standalone mode (installed PWA)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }
  // Check for iOS
  if (window.navigator.standalone === true) {
    return true;
  }
  return false;
}
